import { Channel } from 'client/model/skill';

import { routes } from '../../lib/routes';
import { UserEntity } from '../../types/utils';
import { callApi } from '../utils';

interface CreateOneTimeShareParams {
    skillId: string;
}

export const createOneTimeShare = async ({ skillId }: CreateOneTimeShareParams, channel: Channel) => {
    return callApi<string>({
        method: 'POST',
        url: routes.app.appStoreApi(`/apps/${skillId}/shares/link`),
        queryParams: { channel },
    });
};

interface GetUserSharesParams {
    skillId: string;
}

export const getUserShares = async ({ skillId }: GetUserSharesParams, channel: Channel) => {
    return callApi<UserEntity[]>({
        method: 'GET',
        url: routes.app.appStoreApi(`/apps/${skillId}/shares/users`),
        queryParams: { channel },
    });
};

export const getUserSharesList = async ({ skillId }: GetUserSharesParams, channel: Channel) => {
    return callApi<{ users: UserEntity[]; canBeShared?: boolean }>({
        method: 'GET',
        url: routes.app.appStoreApi(`/apps/${skillId}/shares/users-list`),
        queryParams: { channel },
    });
};

interface DeleteUserShareParams {
    skillId: string;
    userId: string;
}

export const deleteUserShare = async ({ skillId, userId }: DeleteUserShareParams, channel: Channel) => {
    return callApi<'ok'>({
        method: 'DELETE',
        url: routes.app.appStoreApi(`/apps/${skillId}/shares/users/${userId}`),
        queryParams: { channel },
    });
};
